import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";
import _ from 'lodash'

export const miImageSlice = createSlice({
  name: "miImage",
  initialState: {
    boxTags: {
      'AI answer': true,
      'HI answer': true,
      'Disable Boxes': true
    },
    imageDetails: [],
    imageEditorConfig: {
      imageDetails: null,
      classificationConfig: null
    }
  },
  reducers: {
    setBoxTags(state, action) {
      state.boxTags = action.payload;
    },
    setImageDetails(state, action) {
      state.imageDetails = action.payload;
    },
    setImageEditorData(state, action) {
      const filteredData = action.payload.imageDetails.data.filter(r => r.width !== 1777);
      let imageDetails = _.cloneDeep(action.payload.imageDetails);
      imageDetails.data = filteredData
      console.log('here', action.payload.imageDetails.data, filteredData, imageDetails);

      state.imageEditorConfig.imageDetails = imageDetails;
      state.imageEditorConfig.classificationConfig = action.payload.classificationConfig;
    }
  }
})